import React, { useEffect, useState } from 'react';
import { Container, Grid, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import DashboardCard from './DashboardCard';
import Sales from './Sales';
import { useDispatch, useSelector } from 'react-redux';
import {
  AccountBalance,
  Money,
  TrendingUpOutlined,
  PersonOutlined,
  VpnKeyRounded
} from '@material-ui/icons';
import { getDashboardData } from 'src/store/actions/DashboardActions';
import DashboardGraph from './DashboardGraph';
import { formatNumber } from 'src/utils/getInitials';
import ReportsGraph from '../reports/components/ReportsGraph';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const SuperUserDashboard = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [desktopValues, setDesktopValues] = useState({
    data: {
      customers: 0,
      keys: 0,
      pointLeft: 0,
      pointUsed: 0,
      requestCost: 0,
      successfulRequest: 0,
      failedRequest: 0,
      failedSummary: null,
      successSummary: null
    }
  });
  const dashboardData = useSelector((state) => state.Dashboard.dashboardData);
  const profile = useSelector((state) => state.Auth.companyProfile);

  useEffect(() => {
    dispatch(getDashboardData());
  }, []);

  useEffect(() => {
    if (dashboardData) {
      setDesktopValues((values) => ({
        ...values,
        data: {
          ...values.data,
          customers: dashboardData?.customers[0].total,
          keys: dashboardData?.keys[0].total,
          pointLeft: dashboardData?.pointLeft[0].total,
          pointUsed: dashboardData?.pointUsed[0].total,
          requestCost: dashboardData?.requestCost[0].total,
          successfulRequest: dashboardData?.requestCount[0].successCount,
          failedRequest: dashboardData?.requestCount[0].failedCount,
          failedSummary: dashboardData?.failedSummary,
          successSummary: dashboardData?.successSummary
        }
      }));
    }
    // }
  }, [dashboardData]);

  return (
    <Page className={classes.root} title="Dashboard">
      <Container maxWidth={false}>
        <Grid container spacing={3}>
          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Total Customers"
              icon={<PersonOutlined fontSize="small" />}
              value={formatNumber(desktopValues?.data.customers)}
            />
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Keys"
              icon={<VpnKeyRounded fontSize="small" />}
              value={desktopValues?.data.keys}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Successful Request Count"
              icon={<TrendingUpOutlined fontSize="small" />}
              value={formatNumber(desktopValues?.data.successfulRequest)}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Failed Request Count"
              icon={<TrendingUpOutlined fontSize="small" />}
              value={formatNumber(desktopValues?.data.failedRequest)}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Points Used"
              icon={<TrendingUpOutlined fontSize="small" />}
              value={formatNumber(
                Math.round(desktopValues?.data.pointUsed * 1000) / 1000
              )}
            />
          </Grid>

          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <DashboardCard
              title="Total Points"
              icon={<TrendingUpOutlined fontSize="small" />}
              value={formatNumber(desktopValues?.data.pointLeft)}
            />
          </Grid>

          <Grid item lg={12} md={12} xl={12} xs={12}>
            <ReportsGraph isDashboard />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default SuperUserDashboard;
